import { maybe, objectOf } from "@altostra/type-validations";
import { boolean, number } from "@altostra/type-validations/lib/primitives";

export const isGetAppGroupIdFigmaOauthStatusResult = objectOf({
  connected: boolean,
  expires_at: maybe(number),
});
